import { gql } from '@apollo/client';

export default gql`
  query ProjectMapQuery($projectId: Int, $previewReportId: UUID!) {
    allProjectReports(condition: { projectId: $projectId }) {
      nodes {
        projectId
        reportId
        reportJobByReportId {
          params
          targetGroupName
          reportSummariesByReportId {
            nodes {
              productByProductId {
                id
                name
              }
              version
              pq
            }
          }
        }
      }
    }
    previewReport: allReportJobs(condition: { reportId: $previewReportId }) {
      nodes {
        reportId
        params
        targetGroupName
        reportSummariesByReportId {
          nodes {
            productByProductId {
              id
              name
            }
            version
            pq
          }
        }
      }
    }
  }
`;
